import React from "react";
import { Redirect, Route } from "react-router";
import jwt from "jsonwebtoken";
const PublicRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("Token") || "";
  const defaulttheme = token ? jwt.decode(token)["default"] : "";
  return (
    <Route
      {...rest}
      render={(props) => {
        return !token ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: defaulttheme }} />
        );
      }}
    />
  );
};
export default PublicRoute;
